<!-- 城市地图车辆分布数据 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure.vue"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCodeList":["2KNTYVWC"],
                "areaId": "440000000"
                },
            responseCode: {
                    "data": {
                        "converAreaRecords": [
                            {
                                "areaId": "440100000",
                                "areaName": "广州市",
                                "areaParkingNumber": 0,
                                "areaParkingPrecent": "0.0%"
                            },
                            {
                                "areaId": "440200000",
                                "areaName": "韶关市",
                                "areaParkingNumber": 0,
                                "areaParkingPrecent": "0.0%"
                            },
                            {
                                "areaId": "440300000",
                                "areaName": "深圳市",
                                "areaParkingNumber": 0,
                                "areaParkingPrecent": "0.0%"
                            },
                            {
                                "areaId": "440400000",
                                "areaName": "珠海市",
                                "areaParkingNumber": 0,
                                "areaParkingPrecent": "0.0%"
                            },
                            {
                                "areaId": "440500000",
                                "areaName": "汕头市",
                                "areaParkingNumber": 0,
                                "areaParkingPrecent": "0.0%"
                            },
                            {
                                "areaId": "440600000",
                                "areaName": "佛山市",
                                "areaParkingNumber": 1,
                                "areaParkingPrecent": "100.0%"
                            },
                            {
                                "areaId": "440700000",
                                "areaName": "江门市",
                                "areaParkingNumber": 0,
                                "areaParkingPrecent": "0.0%"
                            },
                            {
                                "areaId": "440800000",
                                "areaName": "湛江市",
                                "areaParkingNumber": 0,
                                "areaParkingPrecent": "0.0%"
                            },
                            {
                                "areaId": "440900000",
                                "areaName": "茂名市",
                                "areaParkingNumber": 0,
                                "areaParkingPrecent": "0.0%"
                            },
                            {
                                "areaId": "441200000",
                                "areaName": "肇庆市",
                                "areaParkingNumber": 0,
                                "areaParkingPrecent": "0.0%"
                            },
                            {
                                "areaId": "441300000",
                                "areaName": "惠州市",
                                "areaParkingNumber": 0,
                                "areaParkingPrecent": "0.0%"
                            },
                            {
                                "areaId": "441400000",
                                "areaName": "梅州市",
                                "areaParkingNumber": 0,
                                "areaParkingPrecent": "0.0%"
                            },
                            {
                                "areaId": "441500000",
                                "areaName": "汕尾市",
                                "areaParkingNumber": 0,
                                "areaParkingPrecent": "0.0%"
                            },
                            {
                                "areaId": "441600000",
                                "areaName": "河源市",
                                "areaParkingNumber": 0,
                                "areaParkingPrecent": "0.0%"
                            },
                            {
                                "areaId": "441700000",
                                "areaName": "阳江市",
                                "areaParkingNumber": 0,
                                "areaParkingPrecent": "0.0%"
                            },
                            {
                                "areaId": "441800000",
                                "areaName": "清远市",
                                "areaParkingNumber": 0,
                                "areaParkingPrecent": "0.0%"
                            },
                            {
                                "areaId": "441900000",
                                "areaName": "东莞市",
                                "areaParkingNumber": 0,
                                "areaParkingPrecent": "0.0%"
                            },
                            {
                                "areaId": "442000000",
                                "areaName": "中山市",
                                "areaParkingNumber": 0,
                                "areaParkingPrecent": "0.0%"
                            },
                            {
                                "areaId": "445100000",
                                "areaName": "潮州市",
                                "areaParkingNumber": 0,
                                "areaParkingPrecent": "0.0%"
                            },
                            {
                                "areaId": "445200000",
                                "areaName": "揭阳市",
                                "areaParkingNumber": 0,
                                "areaParkingPrecent": "0.0%"
                            },
                            {
                                "areaId": "445300000",
                                "areaName": "云浮市",
                                "areaParkingNumber": 0,
                                "areaParkingPrecent": "0.0%"
                            }
                        ],
                        "parkLocations": [
                            {
                                "gpsX": 113.159355,
                                "gpsY": 23.02129,
                                "parkName": "开发停车场2",
                                "parkSysType": 0,
                                "parkSysTypeString": "传统停车场"
                            }
                        ],
                        "parkingNumber": 1,
                        "parkingSpaceNumber": 100,
                        "parkingTypeRecords": [
                            {
                                "parkType": 1,
                                "parkTypeNumber": 1,
                                "parkTypePrecent": "100.0%",
                                "parkTypeString": "住宅"
                            },
                            {
                                "parkType": 6,
                                "parkTypeNumber": 0,
                                "parkTypePrecent": "0.0%",
                                "parkTypeString": "其它"
                            }
                        ]
                    },
                    "message": "业务成功",
                    "resultCode": 0,
                    "status": 1
                },infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取城市地图车辆分布数据",
                t_url: this.commonUrls.test+"cityMapCarDistribution",
                p_url: this.commonUrls.prod+"cityMapCarDistribution",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCodeList', info2: '是', info3: 'String[]', info4: '停车场编码数组' },
                        { info1: 'areaId', info2: '是', info3: 'String', info4: '区域id' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkingSpaceNumber', info2: '是', info3: 'long', info4: '覆盖车位数' },
                        { info1: 'parkingNumber', info2: '是', info3: 'long', info4: '运营车场数' },
                        { info1: 'parkingTypeRecords', info2: '是', info3: 'JSONArray', info4: '车场类型分布' },
                        { info1: 'parkLocations', info2: '是', info3: 'JSONArray', info4: '停车场位置' },
                        { info1: 'converAreaRecords', info2: '是', info3: 'JSONArray', info4: '覆盖区域排名，根据areaId，确定为参数区域id的下一级数据，如果是非areaId，则该项为空。如：传的是省级，返回的是市一级' },
                        ]
                },{
                    titleName: 'parkingTypeRecords',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkTypeNumber', info2: '是', info3: 'long', info4: '车场类型数量' },
                        { info1: 'parkTypeString', info2: '是', info3: 'String', info4: '车场类型描述' },
                        { info1: 'parkType', info2: '是', info3: 'Integer', info4: '车场类型' },
                        { info1: 'parkTypePrecent', info2: '是', info3: 'String', info4: '车场类型所占百分比' },
                        ]
                },{
                    titleName: 'parkLocations',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkName', info2: '是', info3: 'String', info4: '停车场名称' },
                        { info1: 'parkSysType', info2: '是', info3: 'Integer', info4: '停车场系统类型' },
                        { info1: 'parkSysTypeString', info2: '是', info3: 'String', info4: '停车场系统类型描述' },
                        { info1: 'gpsX', info2: '是', info3: 'double', info4: 'Gps的x坐标值' },
                        { info1: 'gpsY', info2: '是', info3: 'double', info4: 'Gps的y坐标值' },
                        ]
                },{
                    titleName: 'converAreaRecords',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'areaParkingNumber', info2: '是', info3: 'long', info4: '覆盖区域停车场数' },
                        { info1: 'areaId', info2: '是', info3: 'String', info4: '区域id' },
                        { info1: 'areaName', info2: '是', info3: 'String', info4: '区域名称' },
                        { info1: 'areaParkingPrecent', info2: '是', info3: 'String', info4: '覆盖区域所占百分比' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/dataAnalysis/cityMapCarDistribution.vue